import React, {useCallback, useEffect, useState} from "react";

import {OrderDetailType} from "../../pages/OrdersPage";
import OrderCard from "./OrderCard";

import ColorSchema from "../../assets/kits/colors";
import InsufficientProductDrawer from "./insufficientProductDrawer";
import BoxSlider from "../common/slider/BoxSlider";
import {getBoxByPosition} from "../../utilities/apiTools";

interface OrdersSectionProps {
    unfinishedOrders: OrderDetailType[];
    finishedOrders: OrderDetailType[];
}

const OrdersSection: React.FC<OrdersSectionProps> = ({
                                                         unfinishedOrders,
                                                         finishedOrders,
                                                     }) => {
    const [isOpened, setIsOpened] = useState(false);
    const [info, setInfo] = useState<{
        supplierId: number;
        titles: string[];
    }>({
        supplierId: 0,
        titles: [],
    });

    // open insufficient products drawer
    const openInsufficientDrawer = useCallback(
        (theSupplierId: number, theTitles: string[]) => {
            setIsOpened(true);
            setInfo({
                supplierId: theSupplierId,
                titles: theTitles,
            });
        },
        []
    );

    const [boxBanners, setBoxBanners] = useState({});
    // @ts-ignore
    const loadBanner = async () => setBoxBanners(await getBoxByPosition("c6,c7"));

    useEffect(()=> {
        loadBanner();
    },[])

    return (
        <div className="order-section pd-t-8">
            {/*@ts-ignore*/}
            {(boxBanners.c6) && (
                <div className="mr-x-20 mr-b-12">
                    {/*@ts-ignore*/}
                    <BoxSlider banner={boxBanners.c6}/>
                </div>
            )}

            {unfinishedOrders.length !== 0 && (
                <div>
                    <h4 className="title-h3-b mr-x-20" style={{color: "#000000"}}>
                        سفارش‌های فعال
                    </h4>
                    {unfinishedOrders.reduce<JSX.Element[]>((total, order, index) => {
                        if (index !== 0) {
                            total.push(
                                <hr
                                    key={`unfinished-separator-${index}`}
                                    className="mr-y-12 mr-x-20"
                                    style={{height: 1}}
                                />
                            );
                        }
                        total.push(
                            <OrderCard order={order} key={`unfinished-order-${order.id}`}/>
                        );
                        return total;
                    }, [])}
                </div>
            )}
            {unfinishedOrders.length !== 0 && finishedOrders.length !== 0 && (
                <hr
                    className="mr-y-40"
                    style={{
                        width: "100%",
                        color: ColorSchema.foreground_background_me,
                    }}
                />
            )}

            {/*@ts-ignore*/}
            {(boxBanners.c7) && (
                <div className="mr-x-20 mr-b-12">
                    {/*@ts-ignore*/}
                    <BoxSlider banner={boxBanners.c7}/>
                </div>
            )}

            {finishedOrders.length !== 0 && (
                <div>
                    <h4 className="title-h3-b mr-x-20" style={{color: "#000000"}}>
                        سفارش‌های پیشین
                    </h4>
                    {finishedOrders.reduce<JSX.Element[]>((total, order, index) => {
                        if (index !== 0) {
                            total.push(
                                <hr
                                    key={`finished-separator-${index}`}
                                    className="mr-y-12 mr-x-20"
                                    style={{height: 1}}
                                />
                            );
                        }
                        total.push(
                            <OrderCard
                                order={order}
                                isFinished
                                openInsufficientDrawer={openInsufficientDrawer}
                                key={`finished-order-${order.id}`}
                            />
                        );
                        return total;
                    }, [])}
                </div>
            )}
            <InsufficientProductDrawer
                supplierId={info.supplierId}
                productTitles={info.titles}
                isOpened={isOpened}
                setIsOpened={setIsOpened}
            />
        </div>
    );
};

export default OrdersSection;
